<template>
  <base-chart
    title="Payment Method Distribution"
    :options="chartOptions"
    :height="height"
    :show-data-zoom="false"
    @chart-click="handleSliceClick"
  />
</template>

<script>
import BaseChart from './BaseChart.vue'
import ApiMixin from '@/mixins/api'

export default {
  name: 'PaymentMethodChart',
  components: {
    BaseChart
  },
  mixins: [ApiMixin],
  props: {
    height: {
      type: String,
      default: '400px'
    },
    chartType: {
      type: String,
      default: 'pie',
      validator: (value) => ['pie', 'doughnut'].includes(value)
    }
  },
  data () {
    return {
      loading: false,
      paymentMethods: []
    }
  },
  computed: {
    chartOptions () {
      return {
        title: {
          show: false
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return `${params.name}<br/>Count: ${params.value.toLocaleString()}<br/>Percentage: ${params.percent.toFixed(1)}%`
          }
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'middle',
          formatter: (name) => {
            const item = this.chartData.find(d => d.name === name)
            if (item) {
              return `${name}: ${item.value.toLocaleString()}`
            }
            return name
          }
        },
        series: [
          {
            name: 'Payment Method',
            type: 'pie',
            radius: this.chartType === 'doughnut' ? ['40%', '70%'] : '70%',
            center: ['60%', '50%'],
            data: this.chartData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}: {d}%'
            }
          }
        ]
      }
    },
    chartData () {
      if (this.paymentMethods.length > 0) {
        return this.paymentMethods.map(pm => ({
          name: pm.method,
          value: pm.count
        }))
      }
      return this.generateSampleData()
    }
  },
  mounted () {
    this.fetchPaymentMethodData()
  },
  methods: {
    async fetchPaymentMethodData () {
      this.loading = true
      try {
        const response = await this.api({
          url: '/analytics/payment-methods',
          method: 'get'
        })

        if (response.data && response.data.methods) {
          this.paymentMethods = response.data.methods
        }
      } catch (err) {
        console.error('Error fetching payment method data:', err)
      } finally {
        this.loading = false
      }
    },
    handleSliceClick (params) {
      const method = params.name
      const count = params.value
      this.$emit('drill-down', { method, count })
      this.$router.push({
        name: 'Transactions',
        query: { payment_method: method }
      })
    },
    generateSampleData () {
      return [
        { name: 'Credit Card', value: 1048 },
        { name: 'Debit Card', value: 735 },
        { name: 'ACH', value: 580 },
        { name: 'Cash', value: 234 },
        { name: 'Check', value: 135 }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/PaymentMethodChart.vue